interface Props {
  onClick?: () => void;
}

export const DeleteButton: React.FC<Props> = ({ onClick }) => {
  return (
    <button
      onClick={onClick}
      type="button"
      className="rounded-md border border-gray-300 bg-red-50 py-2 px-4 text-sm font-medium text-red-700 shadow-sm hover:bg-red-100 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
    >
      Delete
    </button>
  );
};
